var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUpiLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1024 466",
    style: {
      enableBackground: "new 0 0 1024 466"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#3D3D3C;}\r\n\t.st1{fill:#70706E;}\r\n\t.st2{fill:#098041;}\r\n\t.st3{fill:#E97626;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_13_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_65_",
    className: "st0",
    d: "M98.1,340.7h6.3l-5.9,24.5c-0.9,3.6-0.7,6.4,0.5,8.2c1.2,1.8,3.4,2.7,6.7,2.7    c3.2,0,5.9-0.9,8-2.7c2.1-1.8,3.5-4.6,4.4-8.2l5.9-24.5h6.4l-6,25.1c-1.3,5.4-3.6,9.5-7,12.2c-3.3,2.7-7.7,4.1-13.1,4.1    c-5.4,0-9.1-1.3-11.1-4c-2-2.7-2.4-6.8-1.1-12.2L98.1,340.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_63_",
    className: "st0",
    d: "M129.5,381l10-41.9l19,24.6c0.5,0.7,1,1.4,1.5,2.2c0.5,0.8,1,1.7,1.6,2.7l6.7-27.9h5.9    l-10,41.8l-19.4-25.1c-0.5-0.7-1-1.4-1.5-2.1c-0.5-0.8-0.9-1.5-1.2-2.4l-6.7,28H129.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_61_",
    className: "st0",
    d: "M173.7,381l9.6-40.3h6.4l-9.6,40.3H173.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_59_",
    className: "st0",
    d: "M189.2,381l9.6-40.3h21.9l-1.3,5.6h-15.5l-2.4,10h15.5l-1.4,5.7h-15.5l-4.5,18.9H189.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_57_",
    className: "st0",
    d: "M218.2,381l9.6-40.3h6.4l-9.6,40.3H218.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_55_",
    className: "st0",
    d: "M233.7,381l9.6-40.3h21.9l-1.3,5.6h-15.5l-2.4,10.1h15.5l-1.4,5.7h-15.5l-3.1,13H257l-1.4,5.9    H233.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_52_",
    className: "st0",
    d: "M263,381l9.6-40.3h8.6c5.6,0,9.5,0.3,11.6,0.9c2.1,0.6,3.9,1.5,5.3,2.9c1.8,1.8,3,4.1,3.5,6.8    c0.5,2.8,0.3,6-0.5,9.5c-0.9,3.6-2.2,6.7-4,9.5c-1.8,2.8-4.1,5-6.8,6.8c-2,1.4-4.2,2.3-6.6,2.9c-2.3,0.6-5.8,0.9-10.4,0.9h-1.7    H263z M270.8,375h5.4c2.9,0,5.2-0.2,6.8-0.6c1.6-0.4,3-1.1,4.3-2c1.8-1.3,3.3-2.9,4.5-4.9c1.2-1.9,2.1-4.2,2.7-6.8    c0.6-2.6,0.8-4.8,0.5-6.7c-0.3-1.9-1-3.6-2.2-4.9c-0.9-1-2-1.6-3.5-2c-1.5-0.4-3.8-0.6-7.1-0.6h-2.3h-2.3L270.8,375z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_49_",
    className: "st0",
    d: "M330.5,362.9l-4.3,18.1h-6l9.6-40.3h9.7c2.9,0,4.9,0.2,6.2,0.5c1.3,0.3,2.3,0.8,3.1,1.6    c1,0.9,1.7,2.2,2,3.8c0.3,1.6,0.2,3.3-0.2,5.2c-0.5,1.9-1.2,3.7-2.3,5.3c-1.1,1.6-2.4,2.9-3.8,3.8c-1.2,0.7-2.5,1.3-3.9,1.6    c-1.4,0.3-3.6,0.5-6.4,0.5h-1.3H330.5z M332.2,357.5h1.6c3.5,0,6-0.4,7.4-1.2c1.4-0.8,2.3-2.2,2.8-4.2c0.5-2.1,0.2-3.7-0.8-4.5    c-1.1-0.9-3.3-1.3-6.6-1.3h-1.6L332.2,357.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_46_",
    className: "st0",
    d: "M372.3,381l-2-10.4h-15.6l-7,10.4h-6.7l29-41.9l9,41.9H372.3z M358.5,365.1h10.9l-1.8-9.2    c-0.1-0.6-0.2-1.3-0.2-2c-0.1-0.8-0.1-1.6-0.1-2.5c-0.4,0.9-0.8,1.7-1.3,2.5c-0.4,0.8-0.8,1.5-1.2,2.1L358.5,365.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_44_",
    className: "st0",
    d: "M388.2,381l4.4-18.4l-8-21.8h6.7l5,13.7c0.1,0.4,0.2,0.8,0.4,1.4c0.2,0.6,0.3,1.2,0.5,1.8    c0.4-0.6,0.8-1.2,1.2-1.8c0.4-0.6,0.8-1.1,1.2-1.6l11.7-13.5h6.4L399,362.5l-4.4,18.4H388.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_42_",
    className: "st0",
    d: "M449.1,361.1c0-0.3,0.1-1.2,0.3-2.6c0.1-1.2,0.2-2.1,0.3-2.9c-0.4,0.9-0.8,1.8-1.3,2.8    c-0.5,0.9-1.1,1.9-1.8,2.8l-15.4,21.5l-5-21.9c-0.2-0.9-0.4-1.8-0.5-2.6c-0.1-0.8-0.2-1.7-0.2-2.5c-0.2,0.8-0.5,1.7-0.8,2.7    c-0.3,0.9-0.7,1.9-1.2,2.9l-9,19.8h-5.9l19.3-42l5.5,25.4c0.1,0.4,0.2,1.1,0.3,2c0.1,0.9,0.3,2.1,0.5,3.5c0.7-1.2,1.6-2.6,2.8-4.4    c0.3-0.5,0.6-0.8,0.7-1.1l17.4-25.4l-0.6,42h-5.9L449.1,361.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_40_",
    className: "st0",
    d: "M459.7,381l9.6-40.3h21.9l-1.3,5.6h-15.5l-2.4,10.1h15.5l-1.4,5.7h-15.5l-3.1,13H483l-1.4,5.9    H459.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_38_",
    className: "st0",
    d: "M488.9,381l10-41.9l19,24.6c0.5,0.7,1,1.4,1.5,2.2c0.5,0.8,1,1.7,1.6,2.7l6.7-27.9h5.9    l-10,41.8l-19.4-25.1c-0.5-0.7-1-1.4-1.5-2.1c-0.5-0.8-0.9-1.5-1.2-2.4l-6.7,28H488.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_36_",
    className: "st0",
    d: "M554,346.2l-8.3,34.7h-6.4l8.3-34.7h-10.4l1.3-5.6h27.2l-1.3,5.6H554z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_34_",
    className: "st0",
    d: "M560.7,372.9l5.7-2.4c0.1,1.8,0.6,3.2,1.7,4.1c1.1,0.9,2.6,1.4,4.6,1.4c1.9,0,3.5-0.5,4.9-1.6    c1.4-1.1,2.3-2.5,2.7-4.3c0.6-2.4-0.8-4.5-4.2-6.3c-0.5-0.3-0.8-0.5-1.1-0.6c-3.8-2.2-6.2-4.1-7.2-5.9c-1-1.8-1.2-3.9-0.6-6.4    c0.8-3.3,2.5-5.9,5.2-8c2.7-2,5.7-3.1,9.3-3.1c2.9,0,5.2,0.6,6.9,1.7c1.7,1.1,2.6,2.8,2.9,4.9l-5.6,2.6c-0.5-1.3-1.1-2.2-1.9-2.8    c-0.8-0.6-1.8-0.9-3-0.9c-1.7,0-3.2,0.5-4.4,1.4c-1.2,0.9-2,2.1-2.4,3.7c-0.6,2.4,1.1,4.7,5,6.8c0.3,0.2,0.5,0.3,0.7,0.4    c3.4,1.8,5.7,3.6,6.7,5.4c1,1.8,1.2,3.9,0.6,6.6c-0.9,3.8-2.8,6.8-5.7,9.1c-2.9,2.2-6.3,3.4-10.3,3.4c-3.3,0-5.9-0.8-7.7-2.4    C561.5,378.1,560.6,375.8,560.7,372.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_32_",
    className: "st0",
    d: "M607.8,381l9.6-40.3h6.4l-9.6,40.3H607.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_30_",
    className: "st0",
    d: "M623.4,381l10-41.9l19,24.6c0.5,0.7,1,1.4,1.5,2.2c0.5,0.8,1,1.7,1.6,2.7l6.7-27.9h5.9    l-10,41.8l-19.4-25.1c-0.5-0.7-1-1.4-1.5-2.1c-0.5-0.8-0.9-1.5-1.2-2.4l-6.7,28H623.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_28_",
    className: "st0",
    d: "M688.5,346.2l-8.3,34.7h-6.4l8.3-34.7h-10.4l1.3-5.6h27.2l-1.3,5.6H688.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_26_",
    className: "st0",
    d: "M695.4,381l9.6-40.3H727l-1.3,5.6h-15.5l-2.4,10.1h15.5l-1.4,5.7h-15.5l-3.1,13h15.5l-1.4,5.9    H695.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_23_",
    className: "st0",
    d: "M734.9,362.9l-4.3,18h-6l9.6-40.3h8.9c2.6,0,4.6,0.2,5.9,0.5c1.4,0.3,2.5,0.9,3.3,1.7    c1,1,1.6,2.2,1.9,3.8c0.3,1.5,0.2,3.2-0.2,5.1c-0.8,3.2-2.1,5.8-4.1,7.6c-2,1.8-4.5,2.9-7.5,3.3l9.1,18.3h-7.2l-8.7-18H734.9z     M736.5,357.8h1.2c3.4,0,5.7-0.4,7-1.2c1.3-0.8,2.2-2.2,2.7-4.3c0.5-2.2,0.3-3.8-0.7-4.7c-1-0.9-3.1-1.4-6.3-1.4h-1.2L736.5,357.8    z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_21_",
    className: "st0",
    d: "M755.4,381l9.6-40.3h21.9l-1.3,5.6h-15.5l-2.4,10h15.5l-1.4,5.7h-15.5l-4.5,18.9H755.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_18_",
    className: "st0",
    d: "M808.2,381l-2-10.4h-15.6l-7,10.4h-6.7l29-41.9l9,41.9H808.2z M794.3,365.1h10.9l-1.8-9.2    c-0.1-0.6-0.2-1.3-0.2-2c-0.1-0.8-0.1-1.6-0.1-2.5c-0.4,0.9-0.8,1.7-1.3,2.5c-0.4,0.8-0.8,1.5-1.2,2.1L794.3,365.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_16_",
    className: "st0",
    d: "M856.5,350.5c-1.4-1.6-3.1-2.8-4.9-3.5c-1.8-0.8-3.8-1.2-6.1-1.2c-4.3,0-8.1,1.4-11.5,4.2    c-3.4,2.8-5.6,6.5-6.7,11c-1,4.3-0.6,7.9,1.4,10.8c1.9,2.8,4.9,4.2,8.9,4.2c2.3,0,4.6-0.4,6.9-1.3c2.3-0.8,4.6-2.1,7-3.8l-1.8,7.4    c-2,1.3-4.1,2.2-6.3,2.8c-2.2,0.6-4.4,0.9-6.8,0.9c-3,0-5.7-0.5-8-1.5c-2.3-1-4.2-2.5-5.7-4.5c-1.5-1.9-2.4-4.2-2.8-6.8    c-0.4-2.6-0.3-5.4,0.5-8.4c0.7-3,1.9-5.7,3.5-8.3c1.6-2.6,3.7-4.9,6.1-6.8c2.4-2,5-3.5,7.8-4.5c2.8-1,5.6-1.5,8.5-1.5    c2.3,0,4.4,0.3,6.4,1c1.9,0.7,3.7,1.7,5.3,3.1L856.5,350.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_14_",
    className: "st0",
    d: "M857.1,381l9.6-40.3h21.9l-1.3,5.6h-15.5l-2.4,10.1h15.5l-1.4,5.7H868l-3.1,13h15.5L879,381    H857.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_6_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_11_",
    className: "st1",
    d: "M740.7,305.6h-43.9l61-220.3h43.9L740.7,305.6z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_9_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_10_",
    className: "st1",
    d: "M717.9,92.2c-3-4.2-7.7-6.3-14.1-6.3H462.6l-11.9,43.2h43.9v0h175.5l-12.8,46.1H481.8l0-0.1      h-43.9l-36.4,131.5h43.9l24.4-88.2h197.3c6.2,0,12-2.1,17.4-6.3c5.4-4.2,9-9.4,10.7-15.6l24.4-88.2      C721.5,101.7,720.9,96.4,717.9,92.2z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_7_",
    className: "st1",
    d: "M375.9,291.8c-2.4,8.7-10.4,14.8-19.4,14.8H130.2c-6.2,0-10.8-2.1-13.8-6.3     c-3-4.2-3.7-9.4-1.9-15.6l55.2-198.8h43.9l-49.3,177.6h175.6l49.3-177.6h43.9L375.9,291.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_5_",
    className: "st2",
    points: "877.5,85.7 933,196.1 816.3,306.5    "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_4_",
    className: "st3",
    points: "838.5,85.7 894,196.1 777.2,306.5    "
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpiLogo);
export default __webpack_public_path__ + "static/media/upi-logo.a7ee79f4c428b8d6e7a3db096a2850fe.svg";
export { ForwardRef as ReactComponent };